
import React, { useState } from "react";
import {
  Popover,
  FormControl,
  Checkbox,
  FormControlLabel,
  Stack,
} from "@mui/material";
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import CustomButton from "./elements/CustomButton/CustomButton";
import "./styles/checkboxFilter.css";

const CustomCheckboxFilter = ({
  searchHandler,
  columnField,
  columnLabel,
  searchFilter,
  options,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(searchFilter || []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClear = () => {
    setSelectedOptions([]);
    searchHandler({ value: "", column: columnField });
    handleClose();
  };

  const handleOptionChange = (event) => {
    const value = event.target.value;
    setSelectedOptions((prev) =>
      prev.includes(value)
        ? prev.filter((option) => option !== value)
        : [...prev, value]
    );
  };

  const handleApply = () => {
    searchHandler({ value: selectedOptions, column: columnField });
    handleClose();
  };

  return (
    <div>
      <div className="cursor-pointer ml-2" onClick={handleOpen}>
        <FilterListOutlinedIcon sx={{fontSize:"18px"}}/>
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        className="popover-container"
        style={{ marginLeft: "50px", marginTop: "10px" }}
      >
        <div className="popover-container">
          <div className="checkbox-options py-2 px-2">
            <FormControl component="fieldset">
              {options.map((option) => (
                <FormControlLabel
                  key={option.value}
                  control={
                    <Checkbox
                      onClick={(event) => event.currentTarget.blur()}
                      checked={selectedOptions.includes(option.value)}
                      onChange={handleOptionChange}
                      value={option.value}
                      className="checkbox-root"
                    />
                  }
                  label={option.label}
                  className="checkbox-label"
                />
              ))}
            </FormControl>
          </div>
          <hr />

          <div
          className="flex items-center gap-1 mt-2"
          >
            <CustomButton
              onClick={handleClear}
              customeClass="primary-custom-button w-[80px] h-[25px]"
            >
              Reset
            </CustomButton>
            <CustomButton
              onClick={handleApply}
              customeClass="gradient-button w-[80px] h-[25px]"
            >
              Apply
            </CustomButton>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default CustomCheckboxFilter;
